import React, { useState } from "react";
import { Button, Card, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import FrequencySideBar from "./FrequencySideBar";
import WordsVisualisation from "./WordsVisualisation";

function MainContainer() {
  const [openMobileSidebar, setOpenMobileSidebar] = useState(false);

  return (
    <div className="w-full min-h-0 flex flex-col md:max-h-[80vh]">
      <div className="md:hidden shrink-0 px-2 pb-2">
        <Button
          icon={<MenuOutlined />}
          className="w-full !rounded-2xl !bg-white/10 !border-white/20 !text-white"
          onClick={() => setOpenMobileSidebar(true)}
        >
          Open Analyses
        </Button>
      </div>

      <div className="flex-1 min-h-0 w-full flex gap-3">
        <div className="hidden md:block w-[30%] min-h-0">
          <Card
            className="
              h-full w-full
              !bg-white/10 !border-white/20 backdrop-blur-md
              overflow-hidden
              [&_.ant-card-body]:h-full
              [&_.ant-card-body]:p-0
              [&_.ant-card-body]:!bg-transparent
            "
          >
            <FrequencySideBar />
          </Card>
        </div>

        <div className="w-full md:w-[70%] min-h-0">
          <Card
            className="
              h-full w-full
              !bg-white/10 !border-white/20 backdrop-blur-md
              overflow-hidden
              [&_.ant-card-body]:h-full
              [&_.ant-card-body]:min-h-0
              [&_.ant-card-body]:p-4
              [&_.ant-card-body]:!bg-transparent
            "
          >
            <WordsVisualisation />
          </Card>
        </div>
      </div>

      <Drawer
        open={openMobileSidebar}
        onClose={() => setOpenMobileSidebar(false)}
        placement="top"
        height="85vh"
        closable={false}
        style={{ background: "transparent" }}
        styles={{
            header: { display: "none" },
            body: { padding: 12, background: "transparent" },
            mask: { background: "rgba(0,0,0,0.45)" },
        }}
        >
        <Card
            className="
            h-full w-full
            !bg-white/10 !border-white/20 backdrop-blur-md
            overflow-hidden
            [&_.ant-card-body]:h-full
            [&_.ant-card-body]:p-0
            [&_.ant-card-body]:!bg-transparent
            "
        >
            <FrequencySideBar />
        </Card>
        </Drawer>
    </div>
  );
}

export default MainContainer;